import { NgStyle } from "@angular/common";
import { Component, computed, input } from "@angular/core";
import { scrollToSection } from "../../utils/scroll-to";

type HeroConfig = {
  slogan: string;
  subpageTitle?: string;
  subSlogan?: string;
  buttonText?: string;
  isBreadCrumbs?: boolean;
  isNewsRoom?: boolean;
  buttonLink?: string;
  background?: string;
};

@Component({
  selector: "app-hero",
  templateUrl: "./hero.component.html",
  styleUrls: ["./hero.component.scss"],
  imports: [NgStyle],
})
export class HeroComponent {
  protected readonly scrollToSection = scrollToSection;
  public readonly config = input.required<HeroConfig>();
  public readonly imageUrl = computed(
    () => `../../../assets/img/${this.config().background ?? "hero"}.webp`,
  );
}
